module.exports = __webpack_public_path__ + "static/img/direct_hit_movie_thum_02.c1a4334.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/direct_hit_movie_thum_02.jpg
// module id = QGo9
// module chunks = 0